import { Component, OnInit } from '@angular/core';

import { MechanicsService } from "../services/mechanics.service"
import { UtilsService } from "../services/utils.service"
import { UserService } from "../services/user.service"
import { SearchService } from '../services/search.service';
import { Patent } from "../interfaces/patent.interface";
import { resolveBgImage } from '../utils';

@Component({
    selector: 'family-details',
    templateUrl: './family-details-public.component.html',
    styleUrls: ['./family-details-public.component.styl'],
    standalone: false
})
export class FamilyDetailsPublicComponent {

	public resolveBgImage
	public isFamilyDisclaimerHidden:boolean

	constructor(public ms: MechanicsService,
		public utils: UtilsService,
		public us: UserService,
		public ss: SearchService) {

		this.resolveBgImage = resolveBgImage

		this.isFamilyDisclaimerHidden = localStorage.getItem("isFamilyDisclaimerHidden") === "true";
	}



	get publicPatents(): Patent[] {
		return this.ms.selectedFamily?.patents?.filter(patent => patent.isExpired !== true) ?? [];
	}

	close() {
		this.ms.condensedSearchContainer = false
		setTimeout(() => {
			this.ms.selectedFamily = null
		}, 300)
	}

	reportInaccuracies() {

		const l=`familyDetails reportInaccuracies() - `

		if (!this.ms.selectedFamily) { // normally impossible
			// console.log(`reportInaccuracies() - No currently selected family`)
			return
		}

		this.ms.toggleModal("Inaccuracies", l)

		this.ms.reportInaccuraciesForm.familyId = this.ms.selectedFamily._id;

	}

	hideFamilyDisclaimer(){
		this.isFamilyDisclaimerHidden = true;
		localStorage.setItem("isFamilyDisclaimerHidden","true")
	}
}
